import { render, staticRenderFns } from "./luckDrawRecord.vue?vue&type=template&id=30f15e53&scoped=true&"
import script from "./luckDrawRecord.vue?vue&type=script&lang=js&"
export * from "./luckDrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./luckDrawRecord.vue?vue&type=style&index=0&id=30f15e53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f15e53",
  null
  
)

export default component.exports